import React,{useState} from 'react'
import { connect } from 'react-redux';
import { GetOrgUserDetails ,setCurrentStep,setShowPopUp,setPopUpMessage,setUserDetails,UpdateOrgUserDetails} from './OrganizationPortalSlice';
import Otp from '../../Shared/Otp/Otp';


function OrganizationOtp(props) {


  const OtpSuccess=async(successProps)=>{
    if(successProps.isSuccess){
     await props.GetOrgUserDetails({ phoneNumber: successProps.phone, userId: successProps.id});
    }
  }

  return (
    <div className='OrganizationOtp'>
      <div className='login_main_title'>
        לאיזור האישי
      </div>
      <Otp
          isDisplayIdentity = {true}
          step1Title={'כמה פרטים ואפשר להיכנס'}
          step2Title={'הקלידו את הקוד שקיבלתם בהודעה'}
          step1ButtonText={'כניסה'}
          step2ButtonText ={'כניסה'}
          onSuccess={(successProps)=>{OtpSuccess(successProps)}} />
    </div>
  )

}

const mapStateToProps = (state) => ({
  currentStep: state.organizationPortal.steps.current,
  userDetails:state.organizationPortal.userDetails
});

const mapDispatchToProps = {
  setCurrentStep,
  GetOrgUserDetails,
  UpdateOrgUserDetails,
  setShowPopUp,
  setPopUpMessage,
  setUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationOtp);
